import { useEffect, useState } from 'react';
import { adminApi, api } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Image, FolderOpen, Mail, AlertCircle } from 'lucide-react';

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const data = await adminApi.getStats();
      setStats(data);
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-serif text-3xl font-medium tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground mt-1">Vue d'ensemble de votre portfolio</p>
      </div>

      {/* Stats Grid */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card data-testid="stat-photos">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">Photos</CardTitle>
            <Image className="h-5 w-5 text-primary" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-serif font-medium">{stats?.photos || 0}</div>
          </CardContent>
        </Card>

        <Card data-testid="stat-categories">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">Catégories</CardTitle>
            <FolderOpen className="h-5 w-5 text-primary" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-serif font-medium">{stats?.categories || 0}</div>
          </CardContent>
        </Card>

        <Card data-testid="stat-messages">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">Messages</CardTitle>
            <Mail className="h-5 w-5 text-primary" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-serif font-medium">{stats?.messages || 0}</div>
          </CardContent>
        </Card>

        <Card data-testid="stat-unread">
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">Non lus</CardTitle>
            <AlertCircle className="h-5 w-5 text-orange-500" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-serif font-medium text-orange-500">{stats?.unread_messages || 0}</div>
          </CardContent>
        </Card>
      </div>

      {/* Quick Tips */}
      <Card className="mt-8">
        <CardHeader>
          <CardTitle className="font-serif text-xl">Bienvenue sur votre dashboard !</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-muted-foreground">
          <p>• Ajoutez des <strong>catégories</strong> pour organiser vos photos</p>
          <p>• Uploadez vos <strong>photos</strong> pour les afficher sur votre portfolio</p>
          <p>• Consultez les <strong>messages</strong> envoyés par vos visiteurs</p>
          <p>• Personnalisez les <strong>paramètres</strong> (réseaux sociaux, texte "À propos")</p>
          <p>• Utilisez l'<strong>aperçu</strong> pour voir le rendu de votre portfolio</p>
        </CardContent>
      </Card>
    </div>
  );
}
